import apiClient from './client';

/**
 * GET /products?page=&page_size=&search=&category=
 * Returns { items, total, page, page_size, pages }
 */
export async function listProducts({ page = 1, pageSize = 50, search, category } = {}) {
  const params = { page, page_size: pageSize };
  if (search) params.search = search;
  if (category) params.category = category;
  const response = await apiClient.get('/products', { params });
  return response.data;
}

export async function getProduct(productId) {
  const response = await apiClient.get(`/products/${productId}`);
  return response.data;
}
